import { Injectable, Injector, inject } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { ComponentPortal } from '@angular/cdk/portal';
import { TranslateService } from '@ngx-translate/core';

import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NotificationsLocation } from '../../../services/notifications/notifications-preferences.domain';
import { WebsocketMessageType } from '../../../services/websocket/websocket.domain';
import { NotificationOverlayRef, NotificationsToast } from '../notifications-toast.domain';
import { NotificationsOverlayService } from '../service/notifications-overlay.service';
import { NotificationToastWrapperComponent } from '../toast/notification-toast-wrapper.component';
import { ToastMessageComponent } from './toast-message.component';

@Injectable({
  providedIn: 'root'
})
export class ToastMessageService {
  private readonly injector = inject(Injector);
  private readonly notificationOverlayService = inject(NotificationsOverlayService);
  private readonly translateService = inject(TranslateService);

  private static readonly MARGIN: string = '10px';
  private static readonly EXPIRY_DURATION: number = 5000;

  private overlayRef: NotificationOverlayRef;

  /**
   * Delegate method to set toast component data
   */
  setToast(message: string, translateParams: Record<string, string | number> = {}, analyticsID?: string): Observable<NotificationsToast> {
    if (this.overlayRef !== undefined) {
      this.notificationOverlayService.close(this.overlayRef);
      this.overlayRef = undefined;
    }
    this.overlayRef = this.notificationOverlayService.open({
      notificationLocation: NotificationsLocation.CENTER,
      margin: ToastMessageService.MARGIN,
      containerPortal: this.getNotificationOverlayConfig()
    });
    const componentRef = this.overlayRef.componentRef;
    const component = componentRef.instance as unknown as NotificationToastWrapperComponent;
    componentRef.setInput('expiryDuration', ToastMessageService.EXPIRY_DURATION);
    componentRef.setInput('toast', {
      type: WebsocketMessageType.TOAST_MESSAGE,
      componentType: ToastMessageComponent,
      message: this.translateService.instant(message, translateParams),
      id: analyticsID
    });
    return outputToObservable(component.onClose).pipe(take(1));
  }

  private getNotificationOverlayConfig(): ComponentPortal<NotificationToastWrapperComponent> {
    return new ComponentPortal(
      NotificationToastWrapperComponent,
      null,
      this.injector
    );
  }
}
